import React, { Component } from "react";
import * as Yup from "yup";
import _ from "lodash";
import { connect } from "react-redux";

import { FormGridField } from "../../../../../../utils/forms/components/FormGrid";
import Form from "../../../../../../utils/forms/components/Form";

import { CreationModes } from "../../../../reducers/gameAttributes.reducer";

import "./FormAttribute.component.scss";

const attrFormFields = _.memoize(({ clients }): FormGridField[] => [
    {
        name: "client_id",
        fieldType: "select",
        fieldOptions: {
            id: "client_id",
            noValueLabel: "Choose a client...",
            label: "Client",
            items: clients
        },
        validation: Yup.string().nullable().required("Field is required."),
        columnClass: "col-12"
    },
    {
        name: "name",
        fieldType: "input",
        fieldOptions: {
            id: "name",
            placeholder: "Name",
            label: "Name"
        },
        validation: Yup.string()
            .required("Field is required.")
            .max(50, "Max. 50 characters."),
        columnClass: "col-6"
    },
    {
        name: "attr_id",
        fieldType: "number",
        fieldOptions: {
            id: "attr_id",
            placeholder: "Id",
            label: "Id"
        },
        validation: Yup.number()
            .integer("Must be an integer")
            .nullable()
            .typeError("Must be an integer")
            .required("Field is required.")
            .min(0, "Min. value of 0."),
        columnClass: "col-6"
    }
]);

export interface FormAttributeProps {
    clients: any[];
    attribute: any;
    creationMode: any;
    action: any;
    save: any;
    isLoading: boolean;
}

class FormAttribute extends Component<FormAttributeProps> {
    form: React.RefObject<Form>;

    constructor(props) {
        super(props);
        this.form = React.createRef();
    }

    formChange = e => {
        let values = { ...e.values };
        let isFormValid = e.isValid;
        this.props.action(values, isFormValid);
    };

    render() {
        let formFields = attrFormFields({
            clients: this.props.clients.map(client => {
                return {
                    value: client.id,
                    label: client.name
                };
            })
        });

        let formKey = `form-initial-${this.props.attribute.values &&
            this.props.attribute.values.hasOwnProperty("id")
            ? this.props.attribute.values.id
            : ""
            }-${this.props.attribute.values.key}`;

        return (
            <div id="form-attribute">
                <div className="form-content">
                    <Form
                        key={formKey}
                        ref={this.form}
                        fields={formFields}
                        initialValues={this.props.attribute.values}
                        onChange={this.formChange}
                    />

                    <div className="row">
                        <div className="col-12">
                            <button
                                className="red-btn edit-btn"
                                onClick={this.props.save}
                                disabled={
                                    !this.props.attribute.isValid ||
                                    this.props.isLoading
                                }
                            >
                                {this.props.creationMode == CreationModes.EDIT
                                    ? "Save"
                                    : "Create"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FormAttribute);
